import { render, staticRenderFns } from "./cashCoupon.vue?vue&type=template&id=248eb607&scoped=true&"
import script from "./cashCoupon.vue?vue&type=script&lang=js&"
export * from "./cashCoupon.vue?vue&type=script&lang=js&"
import style0 from "./cashCoupon.vue?vue&type=style&index=0&id=248eb607&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248eb607",
  null
  
)

export default component.exports